module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-R-46.13d87ebb.png";